import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FirestoreDataService } from 'src/app/services/firestore-data.service';

interface PCMData {
  days: number[];
  theme?: number;
  bg?: string;
  labels?: Array<number | string>;
  backButton: { url: string };
  ctaButton: { url: string; text: string };
  prize?: { image: string; text: string };
}

@Component({
  selector: 'app-easter',
  templateUrl: './easter.html',
  styleUrls: ['./easter.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class Easter implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('pcmParent', { static: false }) pcmParentRef!: ElementRef;

  private readonly fallbackDays = [-1, -1, 1, -1, 0, 2, 2, 2, 2, 2, 2, 2];
  private destroy$ = new Subject<void>();
  private isViewReady = false;
  private hasEntriesLoaded = false;
  private pendingRenderFrame: number | null = null;
  private lastRenderedStateKey: string | null = null;

  private PCM: any;
  private preloadImages: string[] = [];
  private pcmData!: PCMData;

  constructor(private router: Router, private authService: FirestoreDataService, private translate: TranslateService) {
    this.pcmData = {
      days: [...this.fallbackDays],
      theme: 2, // EASTER
    //   bg: '/assets/easter_pcm_images/images/easter/pcm_bg.png',
      backButton: {
        url: "/mainTabs/tabs/home",
      },
      ctaButton: {
        url: "/mainTabs/tabs/home",
        text: this.translate.instant("issue-award.button"),
      },
      prize: {
        image: '/assets/easter_pcm_images/images/icon_credit_0.png',
        text: '£5',
      },
    };
  }

  ngOnInit(): void {
    this.initializePCM();

    this.authService.getV2CloudFunction("getuserentries", {}).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
        if (response) {
            this.pcmData.days = this.normalizeDays(response?.days);
            this.pcmData.labels = this.normalizeLabels(
              response?.labels ?? response?.dates ?? response?.date
            );

            if (response?.prize) {
                this.pcmData.prize = {
                    image: response.prize.image_url,
                    text: this.formatPrizeText(response.prize),
                };
            }
        }

        this.hasEntriesLoaded = true;
        this.renderPCM();
    }, () => {
        this.hasEntriesLoaded = true;
        this.renderPCM();
    });
  }

  formatPrizeText(prize: any): string {
    if (!prize) return "";

    const value = prize.value ?? "";
    const text = prize.prize_text ?? "";

    if (prize.type === "discount_voucher") {
      return `${value}${text}`.trim();
    }

    return `${value} ${text}`.trim();
  }

  ngAfterViewInit(): void {
    this.isViewReady = true;
    this.renderPCM();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.pendingRenderFrame !== null) {
      cancelAnimationFrame(this.pendingRenderFrame);
      this.pendingRenderFrame = null;
    }

    if (this.PCM && this.PCM.Remove) {
      this.PCM.Remove();
    }
  }

  private normalizeDays(days: any): number[] {
    if (!Array.isArray(days) || days.length === 0) {
      return [...this.fallbackDays];
    }

    const normalizedDays = days
      .map((day: any) => Number(day))
      .filter((day: number) => !Number.isNaN(day));

    return normalizedDays.length > 0 ? normalizedDays : [...this.fallbackDays];
  }

  private normalizeLabels(labels: any): Array<number | string> | undefined {
    if (!Array.isArray(labels) || labels.length === 0) {
      return undefined;
    }

    const normalizedLabels = labels
      .map((label: any) => typeof label === 'string' || typeof label === 'number' ? label : null)
      .filter((label: number | string | null): label is number | string => label !== null);

    return normalizedLabels.length > 0 ? normalizedLabels : undefined;
  }

  private renderPCM(): void {
    if (!this.isViewReady || !this.hasEntriesLoaded || !this.PCM || !this.pcmParentRef?.nativeElement) {
      return;
    }

    if (!Array.isArray(this.pcmData.days) || this.pcmData.days.length === 0) {
      this.pcmData.days = [...this.fallbackDays];
    }

    const nextStateKey = JSON.stringify({
      days: this.pcmData.days,
      labels: this.pcmData.labels ?? null,
      prize: this.pcmData.prize ?? null,
    });

    if (this.lastRenderedStateKey === nextStateKey) {
      return;
    }

    this.lastRenderedStateKey = nextStateKey;

    if (this.pendingRenderFrame !== null) {
      cancelAnimationFrame(this.pendingRenderFrame);
    }

    this.pendingRenderFrame = requestAnimationFrame(() => {
      this.pendingRenderFrame = null;

      if (!this.PCM || !this.pcmParentRef?.nativeElement) {
        return;
      }

      this.PCM.Remove?.();

      if (this.PCM.preloadRequest) {
        this.PCM.Init(false, this.pcmParentRef.nativeElement, this.pcmData, null);
      } else {
        this.PCM.Init(this.preloadImages, this.pcmParentRef.nativeElement, this.pcmData, null);
      }
    });
  }

  private initializePCM(): void {
    // Inject the entire main.js codebase here, with slight modifications to make it valid inside the function.
    var PCM_THEMEs =
{
	VALENTINE:1,
	EASTER:2
}
var PCM: any = {
	online : false,
	isReady : false,
	preloadRequest : false,
	domElements : null,
	params : {},
	defaultSettings : {},
	settings : {},
	temp:{},
	_ids : {},
	inputs : {},
	FLAGs:{
	},
	ANIMs:
	{
		CUPID:false,
		PETALS:false,
		WIND:false,
		EASTER_EGG:false
	},
	THEME_NAMEs : {
	    [PCM_THEMEs.VALENTINE]: "valentine",
	    [PCM_THEMEs.EASTER]: "easter"
	},
	spinner: null,
	STATEs : {
		DEFAULT : 0,
		ZOOMED : 1
	},
	PRIZE_STATEs : {
		MISSED : -1,
		AVAILABLE : 0,
		CLAIMED : 1,
		LOCKED : 2
	},
	isMobileOrTablet: function() {
	    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;// Old mobile devices (phones)
	    const isOldMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);// iPads (old and new iPadOS)
	    const isIPad = /iPad/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);// Android tablets (Android but not Mobile)
	    const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);// Windows tablets (touchscreen devices)
	    const isWindowsTablet = /Windows/i.test(ua) && navigator.maxTouchPoints > 1;
	    return isOldMobile || isIPad || isAndroidTablet || isWindowsTablet;
	},
	isOnMobile : null,
	isFullView : false,
	assetsHolder : {},
	imagesPath: "/assets/easter_pcm_images/images/",
	IMAGEs :[],
	state : 0,
	log : function(log){
		//console.log("<PCM>",log);
	},
	warn : function(log){
		console.warn("<PCM>",log);
	},
	error : function(log){
		console.error("<PCM>",log);
	},
	getRandom : function(min, max) {
		return Math.random() * (max - min) + min;
	},
	addButtonsListeners : function(buttons)
	{
		for (var i = 0; i < buttons.length; i++) {
			buttons[i].dataset.screen = "main";
			if(buttons[i].dataset.enabled==null)
				buttons[i].dataset.enabled = 1;
			switch(buttons[i].dataset.anim)
			{
				case "frame":
				buttons[i].addEventListener('click', ((e: any) => PCM.onClickHandler(e)));
				break;

				case "toggle":
				if(!buttons[i].dataset.toggled)
					buttons[i].dataset.toggled = "0";
				break;

				case "scale":
				if(!buttons[i].dataset.scale)
					buttons[i].dataset.scale = "1";
				buttons[i].addEventListener('click', ((e: any) => PCM.onClickHandler(e)));
				break;
			}
			if(this.isOnMobile)
			{
				buttons[i].addEventListener('touchstart', ((e: any) => PCM.onBtnTouched(e)));
			}
			else
			{
				buttons[i].addEventListener('mousedown', ((e: any) => PCM.onBtnTouched(e)));
			}
		}
	},
	removeButtonsListeners : function(buttons)
	{
		for (var i = 0; i < buttons.length; i++) {
			switch(buttons[i].dataset.anim)
			{
				case "frame":
				buttons[i].removeEventListener('click', ((e: any) => PCM.onClickHandler(e)));
				break;

				case "scale":
				buttons[i].removeEventListener('click', ((e: any) => PCM.onClickHandler(e)));
				break;
			}
			if(this.isOnMobile)
			{
				buttons[i].removeEventListener('touchstart', ((e: any) => PCM.onBtnTouched(e)));
			}
			else
			{
				buttons[i].removeEventListener('mousedown', ((e: any) => PCM.onBtnTouched(e)));
			}
		}
	},
	ASSETs : {
		IMAGE : "img"
	},
	RESCALE_MODEs : {
		WIDTH : 0,
		HEIGHT : 1,
		MIN : 2,
		MAX : 3,
		VALUE : 4
	},
	ORIENTATIONs : {
		PORTRAIT : 0,
		LANDSCAPE : 1,
		BOTH : 2
	},
	SHAPEs :
	{
		SPRITE : 0,
		CIRCLE : 1
	},
	Preload : function(addImages,parent,data)
	{
		this.loader ={};
		this.loader.assetsLoaded = 0;
		this.loader.assetsToLoad = 0;
		if(parent)
		{
			this.spinner = {};
			this.spinner.domElements = {};
			this.spinner.domElements.parent = parent;
			var spinnerHTML = '<div class="pcm_spinner_p '+this.THEME_NAMEs[this.theme]+'">';
			switch(this.theme)
			{
				case PCM_THEMEs.VALENTINE:
				spinnerHTML = spinnerHTML + '<div class="pcm_spinner"></div><div class="pcm_heart_spinner"></div>';
				break;
				case PCM_THEMEs.EASTER:
				spinnerHTML = spinnerHTML + '<div class="pcm_egg_spinner"></div><div class="pcm_egg_ring"></div>';
				break;
			}
			spinnerHTML = spinnerHTML +'</div>'
			this.spinner.domElements.parent.innerHTML=spinnerHTML;
			if(data){
				this.loader.data=data;
			}

		}
		this.assetsHolder[this.ASSETs.IMAGE]={};
		if(addImages)
		{
			if (Array.isArray(addImages)) {
				for(var no=0; no<addImages.length; no++)
				{
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no] = {};
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no].name = addImages[no];
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no].img = new Image();
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no].img.onload = function() {PCM.onAssetLoaded();};
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no].img.onerror = function() {PCM.onAssetLoaded();};
					this.assetsHolder[this.ASSETs.IMAGE]["add_"+no].img.src = addImages[no];
					if(this.spinner){this.loader.assetsToLoad++;}
				}
			}
		}
		if(this.preloadRequest){return;}
		this.preloadRequest = true;
		Object.keys(this.IMAGEs).forEach(img => {
			document.documentElement.style.setProperty("--pcm-"+img+"-url","url("+this.imagesPath+this.themePath+this.IMAGEs[img]+")");
			this.assetsHolder[this.ASSETs.IMAGE][img] = {};
			this.assetsHolder[this.ASSETs.IMAGE][img].name = this.IMAGEs[img];
			this.assetsHolder[this.ASSETs.IMAGE][img].url = this.imagesPath+this.themePath+this.IMAGEs[img];
			this.assetsHolder[this.ASSETs.IMAGE][img].img = new Image();
			this.assetsHolder[this.ASSETs.IMAGE][img].img.onload = function() {PCM.onAssetLoaded();};
			this.assetsHolder[this.ASSETs.IMAGE][img].img.onerror  = function() {PCM.onAssetLoaded();};
			this.assetsHolder[this.ASSETs.IMAGE][img].img.src = this.assetsHolder[this.ASSETs.IMAGE][img].url
			if(this.spinner){this.loader.assetsToLoad++;}
		});
	},
	onAssetLoaded : function () {
		this.loader.assetsLoaded++;
		if(this.loader.data)
		{
			if(this.loader.assetsLoaded>=this.loader.assetsToLoad){
				this.Init(false,this.spinner.domElements.parent,this.loader.data,null);
			}
		}
	},
	InitDefaultSettings:function()
	{
		this.svgs = {};
		this.svgs.enabled = false;
		this.svgs.tick = '';
		this.svgs.cross = '';
		this.svgs.front_face = '';
		this.defaultSettings.ids = {
			main : "pcm",
			snow : "snow"
		};
		this.defaultSettings.canvas = {
			width : 1080,
			height : 1920,
			rescaleMode : this.RESCALE_MODEs.MIN,
			orientation : this.ORIENTATIONs.PORTRAIT
		};
		this.defaultSettings.cards = {
			count : 7,
			interactable : false,
			reveal_delay : 3
		};
		this.defaultSettings.grid = {
			zoom : 2, //2.5
			zoom_time : 3,
			width : 1000,
			height : 1800,
			dx : 410,
			dy : 410
		};
		this.defaultSettings.snow = {
			id : this.defaultSettings.ids.snow,
			enabled : true,
			fixed_dt : 0.016,
			dom_scaling : false,
			mobile_ratio : 0.8,
			parent : "container", // container, grid
			shape : this.SHAPEs.CIRCLE
		};
		this.defaultSettings.anims = {
			cards_appear : {
				enabled : true,
				delay : 50
			},
			card_tick_appear : {
				enabled : true,
				delay : 100
			}
		};
	},
	InitTheme:function()
	{
		if(this.FLAGs.THEME_INITIATED){return;}
		this.FLAGs.THEME_INITIATED=true;
		// RESETTING FLAGs
		this.ANIMs.CUPID=false;
		this.themePath = this.THEME_NAMEs[this.theme]+"/";
		this.IMAGEs = {};
		this.IMAGEs["bg"] = "pcm_bg.png";
		this.IMAGEs["atlas"] = "pcm_atlas.png";
		switch(this.theme)
		{
			case PCM_THEMEs.VALENTINE:
			this.IMAGEs["card_front"]="card_front_face.png";
			this.ANIMs.CUPID=true;
			this.ANIMs.PETALS=true;
			document.documentElement.style.setProperty("--pcm-symbol-scale","0.3");
			break;
			case PCM_THEMEs.EASTER:
			this.IMAGEs["card_front"]="card_front_face.png";
			this.ANIMs.WIND=true;
			this.ANIMs.EASTER_EGG=true;
			document.documentElement.style.setProperty("--pcm-symbol-scale","0.35");
			break;
		}
		if(this.ANIMs.CUPID){this.IMAGEs["cupid"]="pcm_cupid.png";}
		if(this.ANIMs.PETALS){this.IMAGEs["petals"]="pcm_petals.png";}
		if(this.IMAGEs["card_front"])
		{
			if(!this.IMAGEs["card_back"])
			{
				document.documentElement.style.setProperty("--pcm-card_back-url","url("+this.imagesPath+this.themePath+this.IMAGEs["card_front"]+")");
			}
		}
	},
	Init:function(preload,parent,data,settings)
	{
		this.theme = PCM_THEMEs.VALENTINE;
		if(data.theme){this.theme=data.theme;}
		this.InitTheme();
		if(preload){
			this.Preload(preload,parent,data,settings);
			return;
		}
		if(window.location.hostname!="localhost"){this.online=true;}
		if(this.spinner)
		{
			this.spinner.domElements.parent.innerHTML = '';
			this.spinner.domElements.parent = null;
			this.spinner = null;
		}
		if(this.isReady){return;}
		this.isOnMobile = this.isMobileOrTablet();
		if(window.location.hostname!="localhost"){this.isFullView=true;}
		PCM._ids.update=window.requestAnimationFrame(this.Update);
		PCM._ids.boundResize = PCM.Resize.bind(PCM);
		window.addEventListener('resize', PCM._ids.boundResize);
		if(settings){this.settings=settings;}
		if(!this.settings.canvas){
			this.settings.canvas = PCM.defaultSettings.canvas;
			this.settings.canvas.aspectRatio = this.settings.canvas.width/this.settings.canvas.height;
			this.settings.canvas.aspectRatioPercentage = this.settings.canvas.aspectRatio*100;
		}
		if(!this.settings.cards){this.settings.cards = PCM.defaultSettings.cards;}
		if(!this.settings.grid){this.settings.grid = PCM.defaultSettings.grid;}
		if(!this.settings.ids){this.settings.ids = PCM.defaultSettings.ids;}
		if(!this.settings.snow){this.settings.snow = PCM.defaultSettings.snow;}
		if(!this.settings.anims){this.settings.anims = PCM.defaultSettings.anims;}
		this.data = data;
		this.settings.cards.count=this.data.days.length;
		if(this.data.theme){this.theme=this.data.theme;}
		if(!parent){this.error("Parent Container Not Found");return;}
		var addHTML = '<div id="'+this.settings.ids.main+'_container" class="pcm_container"><div id="'+this.settings.ids.main+'" class="pcm"></div></div>';
		parent.innerHTML = addHTML;
		this.domElements = {};
		this.domElements.parent = parent;
		this.domElements.self = document.getElementById(this.settings.ids.main);
		this.domElements.container = document.getElementById(this.settings.ids.main+"_container");
		if(this.data.bg)
		{
			this.domElements.self.style.backgroundImage = "url('"+this.data.bg+"')";
		}
		else
		{
			this.domElements.self.style.backgroundImage = "var(--pcm-bg-url)";
		}
		this.domElements.self.style.backgroundRepeat = "no-repeat";
		this.domElements.self.style.backgroundPosition = "bottom center";
		this.domElements.self.style.backgroundSize = "cover"; // optional but recommended
		if(!this.isOnMobile && !this.isFullView)
		{
			this.domElements.self.classList.add("pcm_desktop");
			if(this.settings.canvas.orientation == this.ORIENTATIONs.PORTRAIT)
			{
				this.domElements.self.style.setProperty("--ar", this.settings.canvas.aspectRatio);
			}
		}
		else
		{
			this.domElements.self.classList.add("pcm_mobile");
		}
		var addHTML = '';
		if(this.theme==PCM_THEMEs.EASTER){
			addHTML=addHTML+ '<div id="'+this.settings.ids.main+'_bg_top" class="pcm_atlas pcm_atlas_bg_top_easter pcm_bg_top_'+this.THEME_NAMEs[this.theme]+'"></div>';
		}
		addHTML=addHTML+'<div id="'+this.settings.ids.main+'_content" class="pcm_content" data-resize="scale"></div>'+
		'<div id="'+this.settings.ids.main+'_bottom" class="pcm_bot" data-resize="scale"><div id="'+this.settings.ids.main+'_btn_cta" class="pcm_btn pcm_cta_btn" data-id="cta" data-enabled="1" data-anim="scale" style="display:none;">'+this.data.ctaButton.text+'</div></div>'+
		'<div id="'+this.settings.ids.main+'_top_left" class="pcm_top_left" data-resize="scale"><div id="'+this.settings.ids.main+'_btn_back" class="pcm_btn pcm_back_btn" data-id="back" data-enabled="1" data-anim="scale" style="display:none;">↩</div></div>';
		this.domElements.self.innerHTML = addHTML; 
		this.domElements.content = document.getElementById(this.settings.ids.main+"_content");
		this.domElements.buttons = {};
		this.domElements.buttons.cta = document.getElementById(this.settings.ids.main+"_btn_cta");
		this.domElements.buttons.back = document.getElementById(this.settings.ids.main+"_btn_back");
		this.addButtonsListeners([this.domElements.buttons.cta,this.domElements.buttons.back]);
		this.InitGrid();
		this.EffectsManager.Init();
		this.params.time_scale = 1;
		if(!this.isOnMobile)
		{
			document.addEventListener("mouseup",((e: any) => PCM.onTouchEnd(e)));
			if(!this.isFullView)
			{
				if(this.domElements.container)
				{
					addHTML = '<div id="'+this.settings.ids.main+'_mask_left" class="pcm_mask pcm_mask_left"></div><div id="'+this.settings.ids.main+'_mask_right" class="pcm_mask pcm_mask_right"></div>';
					this.domElements.container.insertAdjacentHTML("beforeend",addHTML);
					this.domElements.masks = {};
					this.domElements.masks.left = document.getElementById(this.settings.ids.main+"_mask_left");
					this.domElements.masks.right = document.getElementById(this.settings.ids.main+"_mask_right");
				}
			}
		}
		else
		{
			document.addEventListener("touchend",((e: any) => PCM.onTouchEnd(e)));
		}
		this.isReady = true;
		this.Resize();
	},
	InitGrid:function()
	{
		if(this.grid){return};
		this.grid = {};
		this.grid.domElements = {};
		var addHTML = '<div id="'+this.settings.ids.main+'_grid" class="pcm_grid"></div>';
		if(this.ANIMs.CUPID){addHTML = addHTML+PCM.Cupid.getHTML();}
		this.domElements.content.insertAdjacentHTML("beforeend",addHTML);
		this.grid.domElements.self = document.getElementById(this.settings.ids.main+"_grid");
		if(this.settings.snow.enabled)
		{
			var snowHTML = '<canvas id="'+this.settings.ids.snow+'_p" class="pcm_snow_p"></canvas>';
			switch(this.settings.snow.parent)
			{
				case "container":
				this.domElements.container.insertAdjacentHTML("beforeend",snowHTML);
				break;
				case "content":
				this.domElements.content.insertAdjacentHTML("beforeend",snowHTML);
				break;
				case "grid":
				this.grid.domElements.self.insertAdjacentHTML("beforeend",snowHTML);
				break;
				case "parent":
				this.domElements.parent.insertAdjacentHTML("beforeend",snowHTML);
				break;
				default:
				break;
			}	
		}
		addHTML = '';
		/*REPLACED BY NEW LOGIC
		this.settings.grid.cols = Math.floor(this.settings.grid.width/this.settings.grid.dx);
		if(this.settings.grid.cols<1){this.settings.grid.cols=1;}
		this.settings.grid.rows = 1;
		this.settings.grid.size = this.settings.grid.cols*this.settings.grid.rows;
		while(this.settings.grid.size<this.settings.cards.count)
		{
			this.settings.grid.rows++;
			this.settings.grid.size = this.settings.grid.cols*this.settings.grid.rows;
		}*/
		var count = this.settings.cards.count;
		var padding = 50;
		var ratio = this.settings.grid.width/this.settings.grid.height;
		this.settings.grid.cols = Math.ceil(Math.sqrt(count * ratio));
		this.settings.grid.rows = Math.ceil(count / this.settings.grid.cols);
		var gridUnitSize = Math.min(
		    (this.settings.grid.width - padding) / this.settings.grid.cols,
		    (this.settings.grid.height - padding) / this.settings.grid.rows
		);
		this.settings.grid.dx = gridUnitSize;
		this.settings.grid.dy = gridUnitSize;
		this.settings.grid.size = this.settings.grid.cols * this.settings.grid.rows;
		this.settings.grid.zoom = Math.floor(this.settings.grid.width/this.settings.grid.dx);
		document.documentElement.style.setProperty("--pcm-card-scale", String(gridUnitSize/210));
		this.params.grid = {};
		this.params.grid.no = 0;
		this.params.grid.pos = [];
		var posX = 0;
		var posY = -(this.settings.grid.rows*0.5-0.5)*this.settings.grid.dy;
		var cardsInRow = 0;
		var numberHTML = '';
		var symbolHTML = '';
		var frontHTML = '';
		var backHTML = '';
		var secondaryHTML = '';
		var statusClass = '';
		var prizeState = 0;
		var cardText = '';
		var cardBackaAddHTML = '';
		for(var i=0; i<this.settings.grid.rows; i++)
		{
			cardBackaAddHTML = '';
			cardsInRow =  this.settings.cards.count-this.params.grid.no;
			if(cardsInRow>this.settings.grid.cols){cardsInRow=this.settings.grid.cols;}
			posX = -(cardsInRow*0.5-0.5)*this.settings.grid.dx;
			for(var j=0; j<this.settings.grid.cols; j++)
			{
				secondaryHTML = '';
				backHTML = '';
				prizeState = this.data.days[this.params.grid.no];
				switch(prizeState)
				{
					case this.PRIZE_STATEs.CLAIMED:
					if(this.svgs.enabled){secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_svg_tick">'+this.svgs.tick+'</div></div>';}
					else
					{
						var tick_style = '';
						if(this.settings.anims.card_tick_appear.enabled){
							tick_style = 'transform:scale(0); opacity:0;';
						}
						secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_tick pcm_atlas pcm_atlas_tick'+'_'+this.THEME_NAMEs[this.theme]+'" style="'+tick_style+'"></div></div>';
					}
					statusClass = 'achieved';
					break;
					case this.PRIZE_STATEs.MISSED:
					if(this.svgs.enabled){secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_svg_cross">'+this.svgs.cross+'</div></div>';}
					else
					{
						var cross_style = '';
						if(this.settings.anims.card_tick_appear.enabled){
							cross_style = 'transform:scale(0); opacity:0;';
						}
						secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_cross pcm_atlas pcm_atlas_cross'+'_'+this.THEME_NAMEs[this.theme]+'" style="'+cross_style+'"></div></div>';
					}
					statusClass = 'missed';
					break;
					case this.PRIZE_STATEs.AVAILABLE:
					secondaryHTML = '';
					statusClass = 'available';
					var prizeImg = '';
					var prizeText = '';
					if(this.data.prize){
						prizeImg = '<img class="pcm_card_prize_icon" src="'+this.data.prize.image+'"></img>'
						prizeText = '<h3 class="pcm_card_prize_text">'+this.data.prize.text+'</h3>'
					}
					if(this.theme==PCM_THEMEs.EASTER)
					{
						cardBackaAddHTML = '<div class="pcm_easter_egg_p"><div class="pcm_easter_egg_t">'+
							'<div class="pcm_easter_egg_c">'+
								'<div class="pcm_easter_egg pcm_egg_'+this.params.grid.no+'"><div class="pcm_easter_egg_shell"></div></div>'+
								'<div class="pcm_easter_egg_top pcm_egg_'+this.params.grid.no+'"><div class="pcm_easter_egg_shell_top pcm_egg_'+this.params.grid.no+'"></div></div>'+
							'</div>'+
							'<div class="pcm_easter_egg_shadow"></div>'+
						'</div></div>';
					}
					backHTML = '<div class="pcm_card_face pcm_card_back">'+cardBackaAddHTML+'<div class="pcm_card_prize">'+prizeImg+prizeText+'</div></div>';
					break;
					case this.PRIZE_STATEs.LOCKED:
					secondaryHTML = '<div class="pcm_card_lock">🔒</div>';
					secondaryHTML = '<div class="pcm_card_lock"></div>';
					statusClass = 'locked';
					break;
				}
				symbolHTML = '<div class="pcm_atlas pcm_atlas_symbol_'+this.params.grid.no+'_'+this.THEME_NAMEs[this.theme]+' pcm_card_front_symbol '+this.THEME_NAMEs[this.theme]+'"></div>';
				this.params.grid.pos.push({ x: posX, y: posY });
				cardText = this.params.grid.no+1;
				if(this.data.labels){cardText=this.data.labels[this.params.grid.no];}
				if(this.params.grid.no<this.settings.cards.count){
					numberHTML = '<h3 class="pcm_card_number">'+cardText+'</h3>';
					if(this.svgs.enabled){
						frontHTML = '<div class="pcm_card_face pcm_card_front pcm_card_front_svg '+statusClass+'">'+this.svgs.front_face+symbolHTML+numberHTML+secondaryHTML+'</div>';
					}
					else
					{
						frontHTML = '<div class="pcm_card_face pcm_card_front pcm_card_front_img '+statusClass+'">'+symbolHTML+numberHTML+secondaryHTML+'</div>';
					}
					addHTML = addHTML + '<div class="pcm_card_p" data-id="card_p" data-row="'+i+'" data-col="'+j+'" data-no="'+this.params.grid.no+'" data-state="'+prizeState+'" style="left:'+this.params.grid.pos[this.params.grid.no].x+'px; top: '+this.params.grid.pos[this.params.grid.no].y+'px;">'+
	    				'<div class="pcm_card '+this.THEME_NAMEs[this.theme]+'" data-id="card" data-no="'+this.params.grid.no+'" data-enabled="1">'+frontHTML+backHTML+
	    				'</div>'+
					'</div>';
				}
				posX = posX + this.settings.grid.dx;
				this.params.grid.no++;
			}
			posY = posY + this.settings.grid.dy;
		}
		this.grid.domElements.self.insertAdjacentHTML("beforeend",addHTML);
		this.grid.domElements.cards = this.grid.domElements.self.querySelectorAll('[data-id="card_p"]');
		for(var no=0; no<this.grid.domElements.cards.length; no++){
			if(this.grid.domElements.cards[no].dataset.id=="card_p"){
				if(parseInt(this.grid.domElements.cards[no].dataset.state)==this.PRIZE_STATEs.AVAILABLE)
				{
					this.grid.domElements.todayCard = this.grid.domElements.cards[no].children[0];
					if(this.settings.cards.interactable)
					{
						this.grid.domElements.todayCard.addEventListener('click', ((e: any) => PCM.onClickHandler(e)));
					}
				}
			}
		}
		this.Animate();
	},
	Animate: function()
	{
		var anmi_timeline = 0;
		var anmi_timeline_1 = 0;
		if(this.settings.anims.cards_appear.enabled)
		{
			this.grid.domElements.cards.forEach(card => {
			    card.classList.add("pcm_card_popin");
			    card.style.animationDelay = anmi_timeline_1 + "ms";
			    anmi_timeline_1=anmi_timeline_1+PCM.settings.anims.cards_appear.delay;
			});
		}
		var anmi_timeline_2 = anmi_timeline_1;
		if(this.settings.anims.card_tick_appear.enabled)
		{
			for(var no=0; no<this.grid.domElements.cards.length; no++){
				if(this.grid.domElements.cards[no].dataset.id=="card_p"){
					var state = parseInt(this.grid.domElements.cards[no].dataset.state);
					if(state==this.PRIZE_STATEs.CLAIMED||state==this.PRIZE_STATEs.MISSED)
					{
						var class_query = 'pcm_card_tick';
						if(state==this.PRIZE_STATEs.CLAIMED){class_query = '.pcm_card_tick';}
						if(state==this.PRIZE_STATEs.MISSED){class_query = '.pcm_card_cross';}
						var dom_el = this.grid.domElements.cards[no].querySelector(class_query);
						if(dom_el)
						{
							dom_el.classList.add("pcm_card_tick_popin");
							dom_el.style.animationDelay = anmi_timeline_2 + "ms";
							anmi_timeline_2 = anmi_timeline_2+this.settings.anims.card_tick_appear.delay;
						}
					}
				}
			}
		}
		anmi_timeline = anmi_timeline_1+anmi_timeline_2;
		if(!this.settings.cards.interactable)
		{
			setTimeout(function(){
		   		PCM.Zoom(true,PCM.grid.domElements.todayCard);
			}, anmi_timeline+500);
		}
	},
	Update : function(ts)
	{
		if (!ts) ts = performance.now();
		if(PCM.params)
		{
			if (PCM.params.pre_ts === undefined){PCM.params.pre_ts=ts;}
			PCM.params.dt = (ts - PCM.params.pre_ts)/1000;
			if(PCM.params.dt==0){PCM.params.dt=0.016;}
			else if(PCM.params.dt>0.2){PCM.params.dt=0.016;}
			PCM.params.dt = PCM.params.dt*PCM.params.time_scale;
			PCM.params.pre_ts = ts;
			if(PCM.isReady){
				if(PCM.EffectsManager)
				{
					PCM.EffectsManager.Update(PCM.params.dt);
					PCM.EffectsManager.Draw();
				}
			}
		}
		PCM._ids.update =window.requestAnimationFrame(PCM.Update);
	},
	Resize : function()
	{
		if(!this.params){return;}
		var params = this.params;
		params.screenWidth = this.domElements.parent.clientWidth;
		params.screenHeight = this.domElements.parent.clientHeight;
		params.aspectRatio = params.screenWidth/params.screenHeight;
		this.log(params.screenWidth+"<>"+params.screenHeight);
		if(this.settings.canvas)
		{
			switch(this.settings.canvas.rescaleMode)
			{
				case this.RESCALE_MODEs.WIDTH:
				params.uiScale = params.screenWidth/this.settings.canvas.width;
				break;
				case this.RESCALE_MODEs.HEIGHT:
				params.uiScale = params.screenHeight/this.settings.canvas.height;
				break;
				case this.RESCALE_MODEs.MIN:
				params.uiScale = Math.min(params.screenWidth/this.settings.canvas.width,params.screenHeight/this.settings.canvas.height)
				break;
				case this.RESCALE_MODEs.MAX:
				params.uiScale = Math.max(params.screenWidth/this.settings.canvas.width,params.screenHeight/this.settings.canvas.height)
				break;
			}
		}
		//params.uiScale = params.uiScale.toFixed(2);
		if(!this.domElements){return;}
		var itemsToRescale = this.domElements.self.querySelectorAll("[data-resize]");
		var itemScale = 1;
		itemsToRescale.forEach(function (item) {
			itemScale = params.uiScale;
			if(item.dataset.scalemul){itemScale = itemScale*parseFloat(item.dataset.scalemul);}
			switch(item.dataset.resize)
			{
				case "scale_w":
				item.style.transform = 'scaleX('+itemScale+')';
				break;

				case "scale_h":
				item.style.transform = 'scaleY('+itemScale+')';
				break;

				case "scale_hp":
				item.style.height = parseInt(item.dataset.initHeight)*itemScale+'px';
				break;

				default:
				item.style.transform = 'scale('+itemScale+','+itemScale+')';
				break;
			}
		});
		if(this.domElements)
		{
			if(this.domElements.masks)
			{
				if(this.domElements.container)
				{
					var delta_width = this.domElements.container.clientWidth-this.domElements.self.clientWidth;
					if(delta_width>0)
					{
						this.domElements.masks.left.style.width = (delta_width*0.5)+'px';
						this.domElements.masks.right.style.width = (delta_width*0.5)+'px';
					}
				}
			}
		}
		if(this.EffectsManager)
		{
			if(this.EffectsManager.canvas)
			{
				this.EffectsManager.Resize(params.screenWidth,params.screenHeight,params.uiScale)	
			}
		}
	},
	ResetSelection : function()
	{
		PCM.state = this.STATEs.DEFAULT;
		PCM.Zoom(false,PCM.params.btn);
	},
	Zoom : function (_in,btn)
	{
		var zoom = this.settings.grid.zoom;
		var centerX = 0;
	    var centerY = 0;
	    var delta_x = 0;
	    var delta_y = 0;
	    PCM.temp.btn = btn;
	    var ctaBtnsDelay = 6000;
	    switch(this.theme)
	    {
	    	case PCM_THEMEs.VALENTINE:
	    	ctaBtnsDelay = 6000;
	    	break;

	    	case PCM_THEMEs.EASTER:
	    	ctaBtnsDelay = 3000;
	    	break;
	    }
		if(_in)
		{
			this.params.isZoomed = true;
			var card_p = this.grid.domElements.cards[parseInt(btn.dataset.no)];
			zoom = this.settings.grid.zoom;
			delta_x = (centerX - card_p.offsetLeft)*zoom;
	    	delta_y = (centerY - card_p.offsetTop)*zoom;
	    	setTimeout(function(){
	    		PCM.HideSurroundingCards(parseInt(card_p.dataset.row),parseInt(card_p.dataset.col));
	    		if(PCM.ANIMs.CUPID){PCM.Cupid.Init();}
	    		if(PCM.ANIMs.EASTER_EGG)
	    		{
	    			setTimeout(function(){
						PCM.FlipCard(btn,"do");
						setTimeout(function(){
							btn.querySelector(".pcm_easter_egg_top").style.animation = 'pcm_easter_egg_open_anim 1.5s ease forwards 1s';
							setTimeout(function(){
								var prizeElement = btn.querySelector(".pcm_card_prize")
								prizeElement.style.display = "block";
								prizeElement.style.animation = 'pcm_easter_prize_open_anim 0.5s ease forwards';
								setTimeout(function(){
									btn.querySelector(".pcm_easter_egg_p").style.animation = 'pcm_easter_egg_hide_anim 0.2s ease forwards';
								}, 1700);
							}, 1500);
						}, 500);
					}, 500);
	    		}
			}, PCM.settings.grid.zoom_time*1000);
			setTimeout(function(){
				PCM.ShowCtaButtons();
			}, PCM.settings.grid.zoom_time*1000+ctaBtnsDelay);
		}
		else
		{
			this.params.isZoomed = false;
			PCM.FlipCard(btn,"reset");
			zoom = 1;
		}
	    this.grid.domElements.self.style.transform = `translate(${delta_x}px, ${delta_y}px) scale(${zoom})`;
	   
	},
	ShowCtaButtons : function()
	{
		this.domElements.buttons.back.style.display = null;
		this.domElements.buttons.back.classList.add("pcm_pop_in_out");
		this.domElements.buttons.cta.style.display = null;
		this.domElements.buttons.cta.classList.add("pcm_cat_btn_appear");
	},
	HideSurroundingCards: function(c_i,c_j)
	{
		var delta_i  = 0;
		var delta_j = 0;
		var hide = false;
		for(var no=0; no<this.grid.domElements.cards.length; no++)
		{
			hide = false;
			delta_i = parseInt(this.grid.domElements.cards[no].dataset.row)-c_i;
			delta_j = parseInt(this.grid.domElements.cards[no].dataset.col)-c_j;
			if(Math.abs(delta_i)==1||Math.abs(delta_j)==1){
				hide = true;
			}
			if(hide)
			{
				this.grid.domElements.cards[no].style.animationDelay = null;
				this.grid.domElements.cards[no].classList.remove("pcm_card_popin");
				this.grid.domElements.cards[no].classList.add("pcm_card_fade_in");
			}
		}
	},
	FlipCard : function (card,action)
	{
		if (!card.classList.contains('pcm_transition_anim')){card.classList.add("pcm_transition_anim");}
		switch(action)
		{
			case "do":
			card.classList.add("pcm_flipped");
			break;

			case "reset":
			card.classList.remove("pcm_flipped");
			break;
		}
	},
	onClickHandler : function(event)
	{
		var btn = event.target;
		var buttonId = btn.dataset.id;
		var enabled = parseInt(btn.dataset.enabled);
		if(enabled==1)
		{
			switch(buttonId)
			{
				case "card":
				if(PCM.state==PCM.STATEs.DEFAULT){
					PCM.state = PCM.STATEs.ZOOMED;
					PCM.params.btn = btn;
					PCM.Zoom(true,btn);
				}
				break;

				case "back":
				window.open(PCM.data.backButton.url, '_blank');
				break;

				case "cta":
				window.open(PCM.data.ctaButton.url, '_blank');
				break;
			}
		}
	},
	onBtnTouched: function(event)
	{
		var btn = event.target;
		if(btn){PCM.inputs.btnTouched = btn;}
		else{return;}
		var enabled = parseInt(btn.dataset.enabled);
		if(enabled!=1){return;}
		switch(btn.dataset.anim)
		{
			case "scale":
			var btnScale = 0.95 * parseFloat(btn.dataset.scale);
			btn.style.transform = "scale("+btnScale+")";
			break;
		}
	},
	onTouchEnd : function(event)
	{
		if(PCM.inputs.btnTouched)
		{
			switch(PCM.inputs.btnTouched.dataset.anim)
			{
				case "scale":
				PCM.inputs.btnTouched.style.transform = "scale("+parseFloat(PCM.inputs.btnTouched.dataset.scale)+")";
				PCM.inputs.btnTouched = null;
				break;
			}
		}
	},
	Remove : function()
	{
		if(!this.isReady){return;}
		if (this._ids.update) {
	        cancelAnimationFrame(this._ids.update);
	        this._ids.update = null;
    	}
    	window.removeEventListener('resize', PCM._ids.boundResize);
    	if(!this.isOnMobile){
			document.removeEventListener("mouseup", ((e: any) => PCM.onTouchEnd(e)));
		}
		else{
			document.removeEventListener("touchend", ((e: any) => PCM.onTouchEnd(e)));
		}
		this.removeButtonsListeners([this.domElements.buttons.cta,this.domElements.buttons.back]);
    	 // --- 3. REMOVE CARD CLICK LISTENERS ---
    	if(this.settings.cards.interactable)
		{
		    if (this.grid && this.grid.domElements && this.grid.domElements.cards) {
		        this.grid.domElements.cards.forEach(card => {
		            const innerCard = card.children[0];
		            if (innerCard) innerCard.removeEventListener('click', ((e: any) => PCM.onClickHandler(e)));
		        });
		    }
		}
	    if (this.domElements && this.domElements.container) {
	        this.domElements.container.remove();
	    }
	    this.domElements = null;
	    this.grid = null;
	    this.params = {};
	    this.isReady = false;
	}
}
PCM.InitDefaultSettings();
PCM.getRandomFromArray = arr => arr[Math.floor(Math.random() * arr.length)];
PCM.EffectsManager = {
	parent : PCM,
	explosions : [],
	Init : function()
	{
		this.isReady = false;
		this.settings = this.parent.settings.snow;
		this.domElements = {};
		this.domElements.self = document.getElementById(this.settings.id+"_p");
		if(!this.domElements.self)
		{
			var snowHTML = '<canvas id="'+this.settings.id+'_p" class="pcm_snow_p"></canvas>';
			if(this.settings.enabled)
			{
				switch(this.settings.parent)
				{
					case "container":
					this.parent.domElements.container.insertAdjacentHTML("beforeend",snowHTML);
					break;
					case "content":
					this.parent.domElements.content.insertAdjacentHTML("beforeend",snowHTML);
					break;
					case "grid":
					this.parent.grid.domElements.self.insertAdjacentHTML("beforeend",snowHTML);
					break;
					case "parent":
					this.parent.domElements.parent.insertAdjacentHTML("beforeend",snowHTML);
					break;
					default:
					break;
				}	
			}
			this.domElements.self = document.getElementById(this.settings.id+"_p");
		}
		this.canvas = this.domElements.self;
		this.ctx = this.canvas.getContext("2d");
		this.params = {};
		this.parent.Resize();
		this.Resize(PCM.params.screenWidth,PCM.params.screenHeight,PCM.params.uiScale);
		if(PCM.ANIMs.PETALS){PCM.Petals.Init(this.canvas,this.ctx,this.params.width,this.params.height);}
		if(PCM.ANIMs.WIND){PCM.Wind.Init(this.canvas,this.ctx,this.params.width,this.params.height);}
		this.isReady=true;
	},
	Update : function(dt)
	{
		if(!this.isReady){return;}
		if(this.settings.fixed_dt>0){dt=this.settings.fixed_dt;}
		if(this.parent.ANIMs.PETALS){PCM.Petals.Update(dt);}
		if(this.parent.ANIMs.WIND){PCM.Wind.Update(dt);}
	},
	Draw : function() {
		if(!this.isReady){return;}
	  	this.ctx.clearRect(0, 0, this.params.width, this.params.height);
	  	if(this.parent.ANIMs.PETALS){PCM.Petals.Draw();}
	  	if(this.parent.ANIMs.WIND){PCM.Wind.Draw();}
	},
	Resize : function(screenWidth,screenHeight,uiScale) {
		if(this.settings.dom_scaling)
		{
			this.params.height = Math.floor((screenHeight*1.1)/uiScale);
			if(PCM.isOnMobile||PCM.isFullView){
				this.params.width = Math.floor(screenWidth/uiScale);
			}
			else
			{
				this.params.width = this.parent.settings.canvas.aspectRatio*Math.floor(screenHeight/uiScale);
			}
		}
		else
		{
			uiScale = 1;
			this.params.height = Math.floor((screenHeight*1.1)/uiScale);
			if(PCM.isOnMobile||PCM.isFullView){
				this.params.width = Math.floor(screenWidth/uiScale);
			}
			else
			{
				this.params.width = this.parent.settings.canvas.aspectRatio*Math.floor(screenHeight/uiScale);
			}
		}
		this.canvas.style.width = this.params.width+"px";
		this.canvas.style.height = this.params.height+"px";
		this.canvas.width = this.params.width;
		this.canvas.height = this.params.height;
		if(this.parent.ANIMs.PETALS){PCM.Petals.Resize(this.params.width,this.params.height);}
		if(this.parent.ANIMs.WIND){PCM.Wind.Resize(this.params.width,this.params.height);}
	}
};
PCM.Petals = {
	parent:PCM,
    particles: [],
    explosions: [],
    params: {},
    isReady:false,
    Init:function(canvas,ctx,width,height)
    {
        this.canvas = canvas;
        this.ctx = ctx;
        this.params.width = width;
        this.params.height = height;
        const parent = this.parent;
        const settings = parent.settings.snow;
        var particles_count_mul = 1;
        var particles_speed_mul = 0.6;
        var particles_scale_mul = 0.5;
        if(this.parent.isOnMobile){particles_count_mul=settings.mobile_ratio;}
        this.layers = [
	        { count: Math.floor(20*particles_count_mul), size: [0.5*particles_scale_mul, 0.6*particles_scale_mul], speed: [20*particles_speed_mul, 50*particles_speed_mul], opacity: [0.2, 0.5] },  // far
	        { count: Math.floor(25*particles_count_mul), size: [0.6*particles_scale_mul, 0.75*particles_scale_mul], speed: [40*particles_speed_mul, 80*particles_speed_mul], opacity: [0.4, 0.7] }, // mid
	        { count: Math.floor(12*particles_count_mul), size: [0.85*particles_scale_mul, 1*particles_scale_mul], speed: [60*particles_speed_mul, 120*particles_speed_mul], opacity: [0.6, 1] }   // near
	    ];
        this.petalImage = new Image();
        this.petalImage.src = parent.assetsHolder[parent.ASSETs.IMAGE]["petals"].url;
        this.frames = [
            { x: 52,  y: 2,  w: 42, h: 42 }, // petal_8
		    { x: 50,  y: 48, w: 43, h: 39 }, // petal_0
		    { x: 139, y: 51, w: 33, h: 42 }, // petal_1
		    { x: 41,  y: 91, w: 34, h: 39 }, // petal_2
		    { x: 139, y: 2,  w: 33, h: 45 }, // petal_3
		    { x: 2,   y: 2,  w: 46, h: 42 }, // petal_4
		    { x: 98,  y: 2,  w: 37, h: 44 }, // petal_5
		    { x: 2,   y: 48, w: 44, h: 39 }, // petal_6
		    { x: 2,   y: 91, w: 35, h: 44 }  // petal_7
        ];
        this.particles = [];
		for (const layer of this.layers) {
	        for (let i = 0; i < layer.count; i++) {
	            const size = PCM.getRandom(layer.size[0], layer.size[1]);
	            this.particles.push({
	            	layer: layer, 
	                x: PCM.getRandom(0, PCM.EffectsManager.params.width),
	                y: PCM.getRandom(0, PCM.EffectsManager.params.height),
	                speedY: PCM.getRandom(layer.speed[0], layer.speed[1]),
	                speedX: PCM.getRandom(-30, 30),
	                driftPhase: PCM.getRandom(0, Math.PI*2),
	                driftSpeed: PCM.getRandom(0.5, 1.5),
	                opacity: PCM.getRandom(layer.opacity[0], layer.opacity[1]),
	                frame: PCM.getRandomFromArray(this.frames),
	                scale: size, 
				    rotation: PCM.getRandom(0, Math.PI * 2),
				    rotationSpeed: PCM.getRandom(-1, 1)
	            });
	        }
	    }
	    this.CreateSprite();
		this.isReady=true;
    },
    CreateSprite : function() {
	    const size = 32;
	    const sprite = document.createElement("canvas");
	    sprite.width = size;
	    sprite.height = size;
	    const sctx = sprite.getContext("2d");
	    // Soft circle
	    const grd = sctx.createRadialGradient(10, 10, 1, 10, 10, 10);
	    grd.addColorStop(0, "rgba(255,255,255,1)");
	    grd.addColorStop(1, "rgba(255,255,255,1)");
	    sctx.fillStyle = grd;
	    sctx.beginPath();
	    sctx.arc(10, 10, 10, 0, Math.PI * 2);
	    sctx.fill();
	    this.sprite = sprite;
	},
    Update:function(dt)
    {
    	if(!this.isReady){return;}
        for (const f of this.particles) {
			f.y += f.speedY*dt;
			f.driftPhase += f.driftSpeed*dt;
			f.x += Math.sin(f.driftPhase) * f.speedX *dt;
			f.rotation += f.rotationSpeed * dt;
			// respawn if below screen
			if (f.y > this.params.height) {
	            f.y = -50;
			    f.x = PCM.getRandom(0, this.params.width);
			    f.opacity = PCM.getRandom(0.4, 1);
			    f.scale   = PCM.getRandom(f.layer.size[0], f.layer.size[1]);
			    f.frame = PCM.getRandomFromArray(this.frames);
			    f.rotation = PCM.getRandom(0, Math.PI * 2);
	        }
			// horizontal wrap
			if (f.x > this.params.width) f.x = 0;
			if (f.x < 0) f.x = this.params.width;
		}
		for (let i = this.explosions.length - 1; i >= 0; i--)
		{
		    const e = this.explosions[i];
		    e.age += dt;
		    if (e.age >= e.life)
		    {
		        this.explosions.splice(i, 1);
		        continue;
		    }
		    e.vy += e.gravity * dt;
		    e.x  += e.vx * dt;
		    e.y  += e.vy * dt;
		    e.rotation += e.rotationSpeed * dt;
		    e.opacity = 1 - (e.age / e.life);
		}
    },
    Draw:function()
    {
        if(!this.isReady){return;}
	  	this.ctx.clearRect(0, 0, this.params.width, this.params.height);
		for (const f of this.particles) {
			const img = this.petalImage;
	        if (!img.complete) continue;
	        const fr = f.frame;
			const w = fr.w * f.scale;
			const h = fr.h * f.scale;
			this.ctx.save();
			this.ctx.globalAlpha = f.opacity;
			this.ctx.translate(f.x, f.y);
			this.ctx.rotate(f.rotation);
			this.ctx.drawImage(
			    img,
			    fr.x, fr.y, fr.w, fr.h, // SOURCE (from CSS)
			    -w / 2, -h / 2,         // DEST
			    w, h
			);
			this.ctx.restore();
		}
		for (const e of this.explosions)
		{
		    const img = this.petalImage;
		    if (!img.complete) continue;
		    const fr = e.frame;
		    const w = fr.w * e.scale;
		    const h = fr.h * e.scale;
		    this.ctx.save();
		    this.ctx.globalAlpha = e.opacity;
		    this.ctx.translate(e.x, e.y);
		    this.ctx.rotate(e.rotation);
		    this.ctx.drawImage(
		        img,
		        fr.x, fr.y, fr.w, fr.h,
		        -w / 2, -h / 2,
		        w, h
		    );
		    this.ctx.restore();
		}
    },
    Resize:function(w,h)
    {
        this.params.width=w;
        this.params.height=h;
    },
	Explode : function(opts: any = {})
	{
	    if (!this.isReady) return;
	    const cx = this.params.width  * 0.5;
    	const cy = this.params.height * 0.5;
	    const count     = opts.count || 50;
	    const power     = opts.power || 350;
	    const gravity   = opts.gravity || 500;
	    const lifeMin   = opts.lifeMin || 1;
	    const lifeMax   = opts.lifeMax || 2;
	    const scaleMin  = opts.scaleMin || 0.2;
	    const scaleMax  = opts.scaleMax || 0.5;
	    for (let i = 0; i < count; i++)
	    {
	        const angle = Math.random() * Math.PI * 2;
	        const speed = PCM.getRandom(power * 0.4, power);
	        this.explosions.push({
	            x: cx,
            	y: cy,
	            vx: Math.cos(angle) * speed,
	            vy: Math.sin(angle) * speed,
	            gravity: gravity,
	            rotation: PCM.getRandom(0, Math.PI * 2),
	            rotationSpeed: PCM.getRandom(-6, 6),
	            opacity: 1,
	            life: PCM.getRandom(lifeMin, lifeMax),
	            age: 0,
	            scale: PCM.getRandom(scaleMin, scaleMax),
	            frame: PCM.getRandomFromArray(this.frames)
	        });
	    }
	}
}
PCM.Wind = {
    parent: PCM,
    particles: [],
    ctx: null,
    canvas: null,
    w: 0,
    h: 0,
    isReady: false,
    Init: function(canvas, ctx, w, h) {
        this.canvas = canvas;
        this.ctx = ctx;
        this.w = w;
        this.h = h;
        this.particles = [];
        const layers = [
            {count: 5, speed: [80,150], len: [25,35], alpha: [0.3,0.5], width:[1,2]},
            {count: 10, speed: [150,200], len: [30,45], alpha: [0.5,0.75], width:[2,3]},
        ];
        for (const layer of layers) {
            for (let i = 0; i < layer.count; i++) {
                this.particles.push({
                    layer: layer,
                    x: PCM.getRandom(-w, w),
                    y: PCM.getRandom(0, h),
                    speed: PCM.getRandom(layer.speed[0], layer.speed[1]),
                    len: PCM.getRandom(layer.len[0], layer.len[1]),
                    alpha: PCM.getRandom(layer.alpha[0], layer.alpha[1]),
                    width: PCM.getRandom(layer.width[0], layer.width[1]),
                    amp: PCM.getRandom(20,40),        // sine amplitude
                    freq: PCM.getRandom(0.01,0.03),   // sine frequency
                    phase: PCM.getRandom(0,Math.PI*2)
                });
            }
        }
        this.isReady = true;
    },
    Update: function(dt) {
        if (!this.isReady) return;
        for (let p of this.particles) {
            p.x += p.speed * dt;
            p.phase += dt * p.speed * 0.02; // advance wave phase
            if (p.x > this.w + p.len) p.x = -p.len; // wrap
        }
    },
    Draw: function() {
        if (!this.isReady) return;
        const ctx = this.ctx;
        for (let p of this.particles) {
            ctx.beginPath();
            ctx.lineWidth = p.width;
            ctx.lineCap = "round";
            // gradient for subtle glow/fade
            const gradient = ctx.createLinearGradient(p.x, p.y, p.x + p.len, p.y);
            gradient.addColorStop(0, "rgba(255,255,255,0)");
            gradient.addColorStop(0.2, `rgba(255,255,255,${p.alpha})`);
            gradient.addColorStop(0.8, `rgba(255,255,255,${p.alpha})`);
            gradient.addColorStop(1, "rgba(255,255,255,0)");
            ctx.strokeStyle = gradient;
            const steps = 10; // distance between points
            for (let i = 0; i <= p.len; i += steps) {
                const px = p.x + i;
                const py = p.y 
                    + Math.sin(i * p.freq + p.phase) * p.amp      // main sine
                    + Math.sin(i * 0.02 + p.phase*0.5) * 5;      // secondary subtle wave
                if (i === 0) ctx.moveTo(px, py);
                else ctx.lineTo(px, py);
            }
            ctx.stroke();
        }
    },
    Resize: function(w,h) {
        this.w = w;
        this.h = h;
    }
};
PCM.Cupid = 
{
	getHTML:function()
	{
		var addHTML = '<div id="'+PCM.settings.ids.main+'_cupid" class="pcm_cupid">';
		addHTML = addHTML+'</div>';
		return addHTML;
	},
	Init:function()
	{
		if(this.isInitialized){return};
		this.domElements={};
		this.domElements.main = document.getElementById(PCM.settings.ids.main+"_cupid");
		var addHTML = '';
		addHTML = addHTML + '<div class="pcm_cupid_body_bone">'
				addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_leg_bot"></div>';
				addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_wings"></div>';
				addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_body"></div>';
				addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_head"></div>';
				addHTML = addHTML + '<div class="pcm_cupid_hand_bone">';
					addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_hand_right_0"></div>';
					addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_bow"></div>';
					addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_arrow"></div>';
					addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_hand_right_1"></div>';
					addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_hand_left"></div>';
				addHTML = addHTML + '</div>';
				addHTML = addHTML + '<div class="pcm_cupid_atlas pcm_cupid_leg_top"></div>';
			addHTML = addHTML + '</div>';
		this.domElements.main.innerHTML = addHTML;
		this.domElements.aim = this.domElements.main.querySelector(".pcm_cupid_hand_bone");
		this.domElements.arrow = this.domElements.main.querySelector(".pcm_cupid_arrow");
		this.Action();
		this.isInitialized=true;
	},
	Action:function()
	{
		const main = PCM.Cupid.domElements.main;
		main.style.animation="pcm_cupid_anim_a0_a 1s linear forwards";
		setTimeout(function(){
			PCM.Cupid.domElements.aim.style.animation="pcm_cupid_anim_a1_a 1s linear forwards";
			setTimeout(function(){
				PCM.Cupid.domElements.arrow.style.animation="pcm_cupid_anim_a2_a 0.5s linear forwards";
				setTimeout(function(){
					PCM.Petals.Explode({});
					PCM.FlipCard(PCM.temp.btn,"do");
					setTimeout(function(){
						var style = getComputedStyle(main);
						main.style.transform = style.transform;
						main.style.opacity = style.opacity;
	                    main.style.animation ="pcm_cupid_anim_a3_a 0.4s linear both";
	                    setTimeout(function(){
	                    	PCM.Cupid.Destroy();
						}, 1000);
					}, 2000);
				}, 500);
			}, 2000);
		}, 1000);
	},
	Destroy:function()
	{
		// Stop all animations
	    if (this.domElements) {
	        for (const key in this.domElements) {
	            if (this.domElements[key]) {
	                this.domElements[key].style.animation = "none";
	            }
	        }
	    }
	    // Remove the main element from the DOM
	    if (this.domElements && this.domElements.main) {
	        this.domElements.main.innerHTML = ""; // clear all child elements
	        if (this.domElements.main.parentNode) {
	            this.domElements.main.parentNode.removeChild(this.domElements.main);
	        }
	    }
	    // Clear references to DOM elements
	    this.domElements=null;
	    this.isInitialized=false;
	}
}


    // Override the click handler to use Angular Router
    const originalOnClick = PCM.onClickHandler;
    PCM.onClickHandler = (event: any) => {
        var btn = event.target;
        var buttonId = btn.dataset.id;
        var enabled = parseInt(btn.dataset.enabled);
        if(enabled==1) {
            if (buttonId === 'back' || buttonId === 'cta') {
                let url = buttonId === 'back' ? PCM.data.backButton.url : PCM.data.ctaButton.url;
                if(url.startsWith('http')) {
                    window.open(url, '_blank');
                } else {
                    this.router.navigateByUrl(url);
                }
            } else {
                originalOnClick(event);
            }
        }
    };

    this.PCM = PCM;
  }
}
